import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LoginPage from "./LoginPage";
import { sendGETRequest } from "../../requestHelper/sendRequest";
import { FrontendCompany } from "node-library/dist/portal";
import { Card } from "@mui/material";
import { SlideShow } from "../../common-components/slideShow";
import LoginImageCard from "./loginImageCard";
import loginImage1 from "../../images/loginPage/login-01.png";
import loginImage2 from "../../images/loginPage/login-02.png";
import loginImage3 from "../../images/loginPage/login-03.png";
import { PrimaryColor } from "node-library/dist/colors";

import LoginPageSkeletonUI from "./skeletonUI/loginPageSkeletonUI";
import Config from "../../globals/Config";

interface Props {}

export default function LoginPageContainer(props: Props) {
	const { t: translation } = useTranslation();

	const [company, setCompany] = useState<FrontendCompany>();

	const [loading, setLoading] = useState<boolean>(false);

	const [activeIndex, setActiveIndex] = useState(0);

	let currentPageToDisplay: JSX.Element;

	useEffect(() => {
		const getCompanyInfo = async () => {
			setLoading(true);

			try {
				const response = await sendGETRequest("/logins/get-company-info", {});
				if (response.success) {
					// Token is valid, redirect to landing page
					if (response?.companyInfo) {
						localStorage.setItem(
							"billionspectra_lims_companyInfo",
							JSON.stringify(response.companyInfo),
						);
						setCompany(response.companyInfo);
						document.title = `LIMS – ${response.companyInfo.companyName}`;
					}
				}
			} catch (err) {
				//no-op
			} finally {
				setLoading(false);
			}
		};
		getCompanyInfo();
	}, []);

	currentPageToDisplay = <LoginPage company={company as FrontendCompany} />;

	const loginSlideContents = [
		{
			headerTextTop: translation("ALaboratoryThat"),
			headerTextBottom: translation("GuaranteesReliableTests"),
			image: loginImage1,
			// footerText: translation("LoginImageOneFooter"),
		},
		{
			headerTextTop: translation("ALaboratoryThat"),
			headerTextBottom: translation("ValuesYourBusiness"),
			image: loginImage2,
			// footerText: translation("LoginImageTwoFooter"),
		},

		{
			headerTextTop: translation("ALaboratory"),
			headerTextBottom: translation("DrivenByInnovation"),
			image: loginImage3,
			// footerText: translation("LoginImageThreeFooter"),
		},
	];

	const settings = {
		autoplay: true,

		autoplaySpeed: 5000,
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: false,
		nextArrow: <></>,
		prevArrow: <></>,
		customPaging: (i: number) => (
			<div
				className="custom-dot"
				style={{
					width: i === activeIndex ? "10px" : "8px", // Current dot is longer
					height: i === activeIndex ? "10px" : "8px",
					backgroundColor: PrimaryColor.PRIMARY_600,
					opacity: i === activeIndex ? 1 : 0.3,
					borderRadius: "50%",
					transition: "width 0.3s ease",
					cursor: "pointer",
				}}
			/>
		),
		beforeChange: (oldIndex: number, newIndex: number) => {
			setActiveIndex(newIndex); // Update active slide index
		},
	};

	return loading ? (
		<LoginPageSkeletonUI></LoginPageSkeletonUI>
	) : (
		<div className="login-page-container">
			<Card
				className="slider-container-card card-border-radius-14p card-normal-padding"
				sx={{
					background:
						"linear-gradient(147.48deg, #ecfdf6 48.86%, #a8f2d6 93.08%)",
					height: "100%",
					boxSizing: "border-box",
				}}
			>
				<SlideShow
					customStyle={{ height: "95%" }}
					slideContent={loginSlideContents.map((content, index) => {
						return (
							<LoginImageCard
								key={index}
								headerTextTop={content.headerTextTop}
								headerTextBottom={content.headerTextBottom}
								imageUrl={content.image}
							></LoginImageCard>
						);
					})}
					slideSettings={settings}
				></SlideShow>
			</Card>

			<div className="login-right-container">
				{currentPageToDisplay}
				<div className="typography-caption typography-bold login-footer">
					{translation("PoweredByBillionSpectra")}
				</div>
			</div>
			<div className="version-footer">{`Version ${Config.appVersion}`}</div>
		</div>
	);
}
